// Copyright (c) 2016 Deere & Company

import JdpClaim from '@deere/cps-it.warranty-model-factory/lib/claim-jd-promise';

export const getUpdatedJdpClaim = (currentClaim, selectedAction) =>
    JdpClaim.update(currentClaim, {
        selectedAction: {
            $set: selectedAction
        }
    });



// WEBPACK FOOTER //
// ./src/claim/marketing/jdp/services/update-jdp-claim.js